import Form from "./form";
import { contactItems, socialItems } from "../data/Contact";

const Contact: React.FC = () => {
  return (
    <>

      <section id="Contact" className="sb-contact">
        <div className="sb-contact-inner">

          <div>
            <p className="sb-contact-label">Contact</p>
            <h3 className="sb-contact-heading">Get in touch</h3>
            <Form />
          </div>

          <div className="sb-contact-side">
            <div className="sb-contact-info">
              {contactItems.map(({ label, value, href, icon }) => (
                <div key={label} className="sb-contact-item">
                  <div className="sb-contact-icon">{icon}</div>
                  <div>
                    <p className="sb-contact-item-label">{label}</p>
                    {href ? (
                      <a href={href} className="sb-contact-item-value">{value}</a>
                    ) : (
                      <span className="sb-contact-item-value">{value}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="sb-contact-divider" />

            <div>
              <p className="sb-contact-social-label">Follow</p>
              <div className="sb-contact-social-list">
                {socialItems.map(({ label, href, icon }) => (
                  
                    <a key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={label}
                    className="sb-contact-social-btn"
                  >
                    {icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default Contact;